/**
 * The first-login welcome survives the redirects that follow a sign-in (data
 * policy, forced password change), so it is parked in sessionStorage and shown
 * by FirstLoginWelcomeDialog once the contributor reaches a regular page.
 */
const FIRST_LOGIN_WELCOME_KEY = 'umbaji-first-login-welcome';
export const FIRST_LOGIN_WELCOME_EVENT = 'umbaji:first-login-welcome';

/** Pages the welcome waits behind: it must not cover a mandatory step. */
const DEFERRED_PATHS = [
  '/login',
  '/signup',
  '/data-policy',
  '/force-change-password',
  '/account-status',
  '/auth/callback',
];

export function queueFirstLoginWelcome(userId: string): void {
  try {
    sessionStorage.setItem(FIRST_LOGIN_WELCOME_KEY, userId);
  } catch {
    // Storage unavailable (private mode): the welcome is simply skipped.
  }
  window.dispatchEvent(new Event(FIRST_LOGIN_WELCOME_EVENT));
}

/** Id of the user waiting for the welcome, if any. */
export function pendingFirstLoginWelcome(): string | null {
  try {
    return sessionStorage.getItem(FIRST_LOGIN_WELCOME_KEY);
  } catch {
    return null;
  }
}

export function clearFirstLoginWelcome(): void {
  try {
    sessionStorage.removeItem(FIRST_LOGIN_WELCOME_KEY);
  } catch {
    // Nothing to clear.
  }
}

export function isWelcomeDeferredOn(pathname: string): boolean {
  const withoutLang = pathname.replace(/^\/(fr|en)(?=\/|$)/, '').replace(/\/$/, '') || '/';
  return DEFERRED_PATHS.some((path) => withoutLang === path || withoutLang.startsWith(`${path}/`));
}

/** Name to greet someone with. */
export function displayNameFor(user: { name?: string; username?: string } | null | undefined): string {
  return user?.name?.trim() || user?.username?.trim() || '';
}
